import {

    USER_LOGIN_EMAIL_CHANGE,
    USER_LOGIN_PASSWORD_CHANGE,
    USER_LOGIN_REQUEST,
    USER_LOGIN_RESPONSE,
    USER_LOGIN_FAILURE,
    USER_LOGIN_RESET_FIELDS

} from "../../actions/types";


const initialState = {

    email: '',
    password: '',
    error: false,
    isFetching: false,
    errorMessage: "",

};

const setFetching = (state, action) => {

    const { email, password } = action.payload;

    return {

        ...state,
        isFetching: true,
        email: email,
        password,
        error: false,
        errorMessage: '',
    };

};

const setEmailChange = (state, action) => {

    const { email } = action.payload;

    return {
        ...state,
        email,
    }

}

const setPasswordChange = (state, action) => {

    const { password } = action.payload;

    return {
        ...state,
        password,
    }

}


const setFailure = (state, action) => {
    const errorMessage = action.payload.errorMessage || "Sorry, we are not able to process your request, Please try again."
    return {
        ...state,
        isFetching: false,
        error: true,
        errorMessage,
    };

};

const setResults = (state, action) => {

    return {
        ...state,
        isFetching: false,
        error: false,
        errorMessage: '',
    };

};

const resetFields = (state, action) => {
    return {
        email: '',
        password: '',
        error: false,
        isFetching: false,
        errorMessage: "",
    }
}



const LoginReducer = (state = initialState, action) => {
    switch (action.type) {
        case USER_LOGIN_EMAIL_CHANGE:
            return setEmailChange(state, action);
            break;
        
        case USER_LOGIN_PASSWORD_CHANGE:
            return setPasswordChange(state, action);
            break;

        case USER_LOGIN_REQUEST:
            return setFetching(state, action);

        case USER_LOGIN_FAILURE:
            return setFailure(state, action);

        case USER_LOGIN_RESPONSE:
            return setResults(state, action);

        case USER_LOGIN_RESET_FIELDS:
            return resetFields(state, action);

        default:
            return state;
            break;
    }
};

export default LoginReducer;
